(function () {
	'use strict';

	function initHoverMenu() {
		const blocks = document.querySelectorAll('.hover-menu-block');

		blocks.forEach(block => {
			const menuItems = block.querySelectorAll('.hover-menu-item');
			const imageContainer = block.querySelector('.hover-menu-image img');

			if (!imageContainer || menuItems.length === 0) return;

			// Preload images for better performance
			const imageUrls = Array.from(menuItems)
				.map(item => item.getAttribute('data-image'))
				.filter(url => url);

			imageUrls.forEach(url => {
				const img = new Image();
				img.src = url;
			});

			// Handle hover events
			menuItems.forEach(item => {
				item.addEventListener('mouseenter', function () {
					const imageUrl = this.getAttribute('data-image');

					if (imageUrl && imageUrl !== imageContainer.src) {
						// Remove active state from all items
						menuItems.forEach(i => i.removeAttribute('data-active'));

						// Add active state to current item
						this.setAttribute('data-active', 'true');

						// Fade out, change image, fade in
						imageContainer.style.opacity = '0';

						setTimeout(() => {
							imageContainer.src = imageUrl;
							imageContainer.style.opacity = '1';
						}, 300);
					}
				});

				// Handle keyboard navigation
				item.addEventListener('focus', function () {
					const imageUrl = this.getAttribute('data-image');

					if (imageUrl && imageUrl !== imageContainer.src) {
						menuItems.forEach(i => i.removeAttribute('data-active'));
						this.setAttribute('data-active', 'true');

						imageContainer.style.opacity = '0';
						setTimeout(() => {
							imageContainer.src = imageUrl;
							imageContainer.style.opacity = '1';
						}, 300);
					}
				});
			});
		});
	}

	// Initialize on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initHoverMenu);
	} else {
		initHoverMenu();
	}

	// Re-initialize for dynamic content (optional)
	if (typeof MutationObserver !== 'undefined') {
		const observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				if (mutation.addedNodes.length) {
					initHoverMenu();
				}
			});
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	}
})();

